export enum UnderLyingEnum {
  COIN_BASED = 'COIN_BASED', // 币本位
  U_BASED = 'U_BASED', // U本位
}

export default UnderLyingEnum;
